<template lang="pug">
    v-content
        v-container.bg(fluid fill-height)
            v-layout(align-center justify-center)
                v-flex(xs12 sm8 md6 lg4)
                    VerificationCard
</template>

<script>
import VerificationCard from "../components/VerificationCard.vue";
export default {
  components: {
    VerificationCard
  }
};
</script>

<style>
.bg {
 /* background: url("../assets/bliss.jpg"); */
  background-size: cover;
}
</style>


